import BaseToolbar from '@material-ui/core/Toolbar'

const Toolbar = BaseToolbar

export default Toolbar
